var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 8.83325C2.46032 8.83325 2.83341 8.46016 2.83341 7.99992C2.83341 7.53968 2.46032 7.16658 2.00008 7.16658C1.53984 7.16658 1.16675 7.53968 1.16675 7.99992C1.16675 8.46016 1.53984 8.83325 2.00008 8.83325Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 2.99992C2.46032 2.99992 2.83341 2.62682 2.83341 2.16659C2.83341 1.70635 2.46032 1.33325 2.00008 1.33325C1.53984 1.33325 1.16675 1.70635 1.16675 2.16659C1.16675 2.62682 1.53984 2.99992 2.00008 2.99992Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 14.6666C2.46032 14.6666 2.83341 14.2935 2.83341 13.8333C2.83341 13.373 2.46032 12.9999 2.00008 12.9999C1.53984 12.9999 1.16675 13.373 1.16675 13.8333C1.16675 14.2935 1.53984 14.6666 2.00008 14.6666Z",
    fill: "#98A2B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 8.83325C2.46032 8.83325 2.83341 8.46016 2.83341 7.99992C2.83341 7.53968 2.46032 7.16658 2.00008 7.16658C1.53984 7.16658 1.16675 7.53968 1.16675 7.99992C1.16675 8.46016 1.53984 8.83325 2.00008 8.83325Z",
    stroke: "#98A2B3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 2.99992C2.46032 2.99992 2.83341 2.62682 2.83341 2.16659C2.83341 1.70635 2.46032 1.33325 2.00008 1.33325C1.53984 1.33325 1.16675 1.70635 1.16675 2.16659C1.16675 2.62682 1.53984 2.99992 2.00008 2.99992Z",
    stroke: "#98A2B3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00008 14.6666C2.46032 14.6666 2.83341 14.2935 2.83341 13.8333C2.83341 13.373 2.46032 12.9999 2.00008 12.9999C1.53984 12.9999 1.16675 13.373 1.16675 13.8333C1.16675 14.2935 1.53984 14.6666 2.00008 14.6666Z",
    stroke: "#98A2B3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.0958671501a919086228805000fc6803.svg";
export { ForwardRef as ReactComponent };